export class AdjustmentEffectivenessPayload {
  adjustmentEffectiveness: number;
}
